import BellOutlined from '@ant-design/icons/BellOutlined';
import CheckOutlined from '@ant-design/icons/CheckOutlined';
import EditOutlined from '@ant-design/icons/EditOutlined';
import NotificationOutlined from '@ant-design/icons/NotificationOutlined';
import PlayCircleOutlined from '@ant-design/icons/PlayCircleOutlined';
import StopOutlined from '@ant-design/icons/StopOutlined';
import Button from 'antd/es/button';
import Dropdown from 'antd/es/dropdown';
import Typography from 'antd/es/typography';
import React from 'react';
import styled from 'styled-components';

const { Title } = Typography;

const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
`;

const EditButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  padding: 0 4px;
  height: 24px;
`;

interface TaskHeaderProps {
  title: string;
  onEditTitle: () => void;
  colorPrimary: string;
  onStartTask: () => void;
}

const TaskHeader: React.FC<TaskHeaderProps> = ({
  title,
  onEditTitle,
  colorPrimary,
  onStartTask,
}) => {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 8,
        width: '100%',
      }}
    >
      <TitleWrapper>
        <Title level={4} style={{ margin: 0 }}>
          {title}
        </Title>
        <EditButton
          type="text"
          icon={<EditOutlined />}
          size="small"
          aria-label="Edit title"
          onClick={onEditTitle}
        />
      </TitleWrapper>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <Dropdown
          menu={{
            items: [
              {
                key: 'all',
                label: 'All Events',
                displayLabel: 'All Events',
                icon: <BellOutlined />,
                description: 'Receive notifications for all updates',
              },
              {
                key: 'important',
                label: 'Important',
                displayLabel: 'Important',
                icon: <NotificationOutlined />,
                description: 'Only receive notifications for major changes',
              },
              {
                key: 'ignore',
                label: 'Disabled',
                displayLabel: 'Disabled',
                icon: <StopOutlined />,
                description: 'Never be notified',
              },
            ].map((item) => ({
              key: item.key,
              label: (
                <div style={{ padding: '4px 0' }}>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                    }}
                  >
                    {item.icon}
                    <span
                      style={{
                        fontWeight:
                          item.key === 'important' ? 'bold' : 'normal',
                      }}
                    >
                      {item.label}
                    </span>
                    {item.key === 'important' && (
                      <CheckOutlined
                        style={{ color: colorPrimary || '#1890ff' }}
                      />
                    )}
                  </div>
                  <div
                    style={{
                      fontSize: '12px',
                      marginTop: '4px',
                      paddingLeft: '24px',
                    }}
                  >
                    {item.description}
                  </div>
                </div>
              ),
            })),
          }}
          trigger={['click']}
        >
          <Button
            icon={<BellOutlined />}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
            }}
          >
            Notify: Important
          </Button>
        </Dropdown>
        <Button onClick={onStartTask} icon={<PlayCircleOutlined />} />
      </div>
    </div>
  );
};

export default TaskHeader;
export { TitleWrapper, EditButton };
